import React, { useState } from 'react'
import SalesStatisticOne from './child/SalesStatisticOne';
import TotalSubscriberOne from './child/TotalSubscriberOne';
import UsersOverviewOne from './child/UsersOverviewOne';
import MapComponent from './child/MapComponent';
import UnitCountOne from './child/UnitCountOne';
import ComplaintSourcesChartsModal from './child/ComplaintSourcesChartsModal';
// "Graph for DCF wise Complaints" (GeneratedContent) hidden on the dashboard.
// import GeneratedContent from './child/GeneratedContent';

const DashBoardLayerOne = () => {
  const [showSourcesModal, setShowSourcesModal] = useState(false);

  return (
    <>
      {/* UnitCountOne */}
      <UnitCountOne />

      <section className="row gy-4 mt-1">
        {/* SalesStatisticOne */}
        <SalesStatisticOne onViewAllSources={() => setShowSourcesModal(true)} />

        {/* TotalSubscriberOne */}
        <TotalSubscriberOne />

        {/* UsersOverviewOne */}
        <UsersOverviewOne />
        
        {/* MapComponent */}
        <MapComponent />

        {/* GeneratedContent (DCF-wise graph) hidden */}
      </section>

      {/* Complaint Sources Modal */}
      <ComplaintSourcesChartsModal 
        show={showSourcesModal} 
        handleClose={() => setShowSourcesModal(false)} 
      />
    </>
  )
}

export default DashBoardLayerOne